import React from 'react';

const WhatsAppIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_6869_94777)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.9915 2.90417C15.122 1.03232 12.6357 0.000949696 9.98652 0C4.52768 0 0.0849978 4.44221 0.0830984 9.90249C0.0821486 11.648 0.538478 13.3518 1.40508 14.8533L0 19.9854L5.24992 18.6083C6.6963 19.3976 8.32503 19.813 9.98227 19.8135H9.98652C15.4444 19.8135 19.8876 15.3708 19.8895 9.91055C19.8904 7.26425 18.8614 4.7765 16.9915 2.90465V2.90417ZM9.98652 18.1411H9.9832C8.50641 18.1407 7.05768 17.7436 5.79365 16.9939L5.49305 16.8154L2.37757 17.6325L3.20903 14.5949L3.01339 14.2834C2.18953 12.9729 1.75409 11.4581 1.75504 9.90298C1.75694 5.36484 5.44936 1.67241 9.98989 1.67241C12.1884 1.67336 14.255 2.53047 15.8091 4.08655C17.3633 5.64216 18.2185 7.71061 18.2176 9.90961C18.2156 14.4482 14.5233 18.1407 9.98652 18.1407V18.1411ZM14.5014 11.9766C14.254 11.8527 13.0375 11.2544 12.8104 11.1718C12.5835 11.0891 12.4187 11.0478 12.2539 11.2957C12.0892 11.5436 11.6148 12.1011 11.4704 12.2658C11.3261 12.4311 11.1817 12.4515 10.9343 12.3275C10.687 12.2036 9.88967 11.9424 8.94425 11.0996C8.20873 10.4433 7.71199 9.63326 7.56768 9.38536C7.42332 9.13751 7.55249 9.00359 7.67591 8.88061C7.78702 8.7695 7.92332 8.59144 8.04724 8.44707C8.17122 8.30271 8.21204 8.19923 8.29464 8.03442C8.37729 7.86917 8.33597 7.72486 8.27425 7.60088C8.21249 7.47696 7.71773 6.25895 7.51116 5.7637C7.31028 5.28127 7.10613 5.3468 6.95464 5.33872C6.81028 5.3316 6.64552 5.33018 6.48028 5.33018C6.31503 5.33018 6.04718 5.39191 5.82022 5.63978C5.59326 5.88762 4.95409 6.48641 4.95409 7.70392C4.95409 8.92144 5.84066 10.0986 5.96459 10.2639C6.08851 10.4291 7.70961 12.9282 10.1917 14.0004C10.7819 14.2554 11.243 14.4078 11.6024 14.5218C12.1951 14.7103 12.7345 14.6838 13.1609 14.6201C13.6362 14.5489 14.6249 14.0213 14.8309 13.4434C15.037 12.8655 15.037 12.3698 14.9753 12.2667C14.9136 12.1637 14.7483 12.1015 14.5009 11.9776L14.5014 11.9766Z"
        fill="#25D366"
      />
    </g>
    <defs>
      <clipPath id="clip0_6869_94777">
        <rect width="19.8895" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

WhatsAppIcon.displayName = 'WhatsAppIcon';
export default WhatsAppIcon;
